class QuizScripts {
	constructor() {
        ( function ( $ ) {
            "use strict";


            // Validações e Máscaras
            function addEventListenerList(list, event, fn) {
                for (var i = 0, len = list.length; i < len; i++) {
                    list[i].addEventListener(event, fn, false);
                }
            }
            const allInputsValid = (form) => {
                let inputs = form instanceof jQuery ? form.find('.input-validate input') : form.querySelectorAll('.input-validate input');
                let valid = true;
            
                inputs.each(function() {
                    let input = this instanceof jQuery ? this : $(this);
            
                    if (input.hasClass('invalid') || (!input.hasClass('invalid') && !input.hasClass('valid'))) {
                        valid = false;
                    }
            
                    if (!input.hasClass('invalid') && !input.hasClass('valid')) {
                        input.addClass('invalid');
                    }
                });
            
                return valid;
            };
            String.prototype.capitalizeAll = function() {
                var splitStr = this.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                return splitStr.join(' ');
            }
            function valid(el) {
                if (el instanceof jQuery) {
                    el.addClass('valid').removeClass('invalid');
                } else {
                    el.classList.add('valid');
                    el.classList.remove('invalid');
                }
            }
            function invalid(el) {
                if (el instanceof jQuery) {
                    el.addClass('invalid').removeClass('valid');
                } else {
                    el.classList.add('invalid');
                    el.classList.remove('valid');
                }
            }

            // Nome
            let nomes = document.querySelectorAll('[name="nome"]');
            addEventListenerList(nomes, 'input', function(e){
                if(this.value.length) {
                    let value = this.value;
                    // value = value.capitalizeAll();
                    // value = value.replace(/ Da /gi, ' da ').replace(/ De /gi, ' de ').replace(/ Do /gi, ' do ').replace(/ Das /gi, ' das ').replace(/ Dos /gi, ' dos ');
                    // this.value = value;
                    if(this.value.length > 3) {
                        valid(this);
                    } else {
                        invalid(this);
                    }
                }
            });

            // E-mail
            function validarEmail(email) {
                var re =
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            }
            let email = document.querySelectorAll('[name="email"]');
            addEventListenerList(email, 'input', function(e){
                if(this.value.length) {
                    let value = this.value;
                    if(validarEmail(value)) {
                        valid(this);
                    } else {
                        invalid(this);
                    }
                }
            });

            // Telefone
            var TelMaskBehavior = function (val) {
                return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
            },
            telOptions = {
                onKeyPress: function(val, e, field, options) {
                    field.mask(TelMaskBehavior.apply({}, arguments), options);
                },
                onChange: function(tel){
                    // console.log(tel);
                    if (tel.length >= 14) {
                        valid($('input[name="telefone"], input[name="whatsapp"]'));
                    } else {
                        invalid($('input[name="telefone"], input[name="whatsapp"]'));
                    }    
                },
                onInvalid: function(val, e, f, invalid, options){
                    jQuery('input[name="telefone"], input[name="whatsapp"]').addClass('invalid');
                    jQuery('input[name="telefone"], input[name="whatsapp"]').closest('.input-validate').addClass('invalid');
                    jQuery('input[name="telefone"], input[name="whatsapp"]').removeClass('valid');
                    jQuery('input[name="telefone"], input[name="whatsapp"]').closest('.input-validate').removeClass('valid');
                }
            };
            // $('input[name="telefone"], input[name="whatsapp"]').mask(TelMaskBehavior, telOptions);
            // END - Validações e Máscaras

            // HSOverlay.open('#gaia-quiz');

            const formQuiz = $('#gaia_quiz_form');
            window.quizCurrentStep = formQuiz.data('step');
            window.quizTotalStep = formQuiz.data('total-step') + 1;
            window.quizValues = [];
            
            $(document).on('click', '.quiz_next_step', function( e ) {
                e.preventDefault();
                const nome = formQuiz.find('#nome');
                const email = formQuiz.find('#email');

                if (window.quizCurrentStep == 1) {
                    if (!allInputsValid(formQuiz)) {
                        return;
                    }
                    $(document).trigger('changeStepQuiz', ['init', {
                        'conversion': 'Quiz Global',
                        'nome': nome.val(),
                        'email': email.val()
                    }]);
                    window.quizCurrentStep++;
                    formQuiz.data('step', window.quizCurrentStep);
                    formQuiz.find('.step').hide();
                    formQuiz.find(`.step${window.quizCurrentStep}`).fadeIn('slow');
                } else {
                    if (!$(`input[name=field_step${window.quizCurrentStep}]`).is(':checked')) {
                        alert(t('quiz.select_option_error'));
                        return;
                    }

                    if (window.quizCurrentStep <= window.quizTotalStep) {
                        $(document).trigger('changeStepQuiz', ['next', {
                            'conversion': 'Quiz Global',
                            'nome': nome.val(),
                            'email': email.val(),
                            'field': $(`input[name=field_step${window.quizCurrentStep}]`).data('field'),
                            'value': $(`input[name=field_step${window.quizCurrentStep}]:checked`).val(),
                            'value_calculate': $(`input[name=field_step${window.quizCurrentStep}]:checked`).data('value')
                        }]);
                        window.quizCurrentStep++;
                        formQuiz.data('step', window.quizCurrentStep);
                        formQuiz.find('.step').hide();
                        formQuiz.find(`.step${window.quizCurrentStep}`).fadeIn('slow');
                    }
                }

                return;
            });

            $(document).on('click', '.quiz_prev_step', function( e ) {
                e.preventDefault();
                if (window.quizCurrentStep > 1) {
                    $(document).trigger('changeStepQuiz', ['prev', {
                        'field': `gaia_step${window.quizCurrentStep-1}`,
                        'value': $(`input[name=field_step${window.quizCurrentStep-1}]:checked`).val(),
                        'value_calculate': $(`input[name=field_step${window.quizCurrentStep-1}]:checked`).data('value'),
                    }]);
                    $(`input[name=field_step${window.quizCurrentStep-1}]`).prop('checked', false);
                    $(`input[name=field_step${window.quizCurrentStep}]`).prop('checked', false);
                    window.quizCurrentStep--;
                    formQuiz.data('step', window.quizCurrentStep);
                    formQuiz.find('.step').hide();
                    formQuiz.find(`.step${window.quizCurrentStep}`).fadeIn('slow');
                }

                return;
            });
            
            $(document).on('change', '.quiz_field_radio', function( e ) {
                e.preventDefault();

                const nome = formQuiz.find('#nome');
                const email = formQuiz.find('#email');

                if (window.quizCurrentStep > 1 && window.quizCurrentStep <= window.quizTotalStep) {
                    if ($(this).is(':checked')) {
                        $(document).trigger('changeStepQuiz', ['next', {
                            'conversion': 'Quiz Europa',
                            'nome': nome.val(),
                            'email': email.val(),
                            'field': $(`input[name=field_step${window.quizCurrentStep}]`).data('field'),
                            'value': $(`input[name=field_step${window.quizCurrentStep}]:checked`).val(),
                            'value_calculate': $(`input[name=field_step${window.quizCurrentStep}]:checked`).data('value'),
                        }]);

                        window.quizCurrentStep++;
                        if (window.quizCurrentStep > window.quizTotalStep) {
                            formQuiz.find('.step').hide();
                            formQuiz.find(`.loading`).fadeIn('slow');
                            setTimeout(() => {
                                window.location = t('quiz.url_result') + window.quizValues.join('') + '&nome=' + nome.val() + '&email=' + email.val();
                            }, 1500);
                            return;
                        } else {
                            formQuiz.data('step', window.quizCurrentStep);
                            formQuiz.find('.step').hide();
                            formQuiz.find(`.step${window.quizCurrentStep}`).fadeIn('slow');
                        }
                    } else {
                        alert(t('quiz.select_option_error'));
                        return;
                    }
                }
                return;
            });

            $('#gaia_quiz_form').on('submit', function( e ){
                e.preventDefault();
                // console.log('Enviando..');
                return;
            });

            // Escuta o evento 'applyFilters'
            $(document).on('changeStepQuiz', function(event, type, data) {
                console.log(type, data);
                if ('init' == type) {
                    gaiaConversionRD(data);
                }
                if ('next' == type && data.field !== '' && data.value !== '') {
                    if (data.value_calculate !== '') window.quizValues.push(data.value_calculate);
                    gaiaConversionRD(data);
                } else if ('next' == type &&  data.value_calculate !== '') {
                    if (data.value_calculate !== '') window.quizValues.push(data.value_calculate);
                }
                if ('prev' == type && data.value_calculate !== '') {
                    window.quizValues = window.quizValues.filter(function (option) {
                        return option !== data.value_calculate;
                    });
                }
            });

            // Conversões RD
            function gaiaConversionRD(source){
                if (!source) return;
                var data = {
                    'action': 'gaia_rd_conversion',
                    'conversion': source.conversion,
                    'nome': source.nome,
                    'email': source.email,
                    'field': source.field,
                    'value': source.value
                };
                $.post(
                    gaiaCustomData.ajax_url,
                    data,
                    function(response){
                        // console.log(response);
                    }
                );
            }

            // Abrir quiz pela url
            let urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('quiz')) {
                HSOverlay.getInstance('#gaia-quiz', true).element.open();
            }

            // Conversão Resultado Quiz
            if (urlParams.has('gaia')) {
                const resultado = $('#conteudo-resultado .resultado.current').data('resultado');
                if (resultado.length) {
                    const nome_param = urlParams.get('nome');
                    const email_param = urlParams.get('email');
                    $(document).trigger('changeStepQuiz', ['next', {
                        'conversion': 'Quiz Global',
                        'nome': nome_param,
                        'email': email_param,
                        'field': 'cf_resultado_quiz',
                        'value': resultado,
                    }]);
                }
            }
        }( jQuery ) );
    }
}

export default QuizScripts